// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f495cbb6","704":"6f5cb7af"}[chunkId] + ".chunk.js";
};